import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class KursDokumentView extends BaseEntity{

    constructor(){
        super();
    }
   
    Datum: NgbDate;    
    Opis: string;

    Deserialize(input: any){
        this.ID = input.ID;      
        this.Datum = input.Datum;
        this.Opis = input.Opis;
       
        return this;
    }

    Serialize(input: KursDokumentView){
        return input;
    }
}